import { startCase } from 'lodash';

export const parseDriverUsernames = (driver) => {
    return driver ? startCase(driver.split(/\s/)[0]) : 'Driver';
};

// Route Name ties (aliasless routes on one resource) fall back to route_number, which keeps offset
// paging stable.
export const routesOrderBy = (sortBy) => {
    const ascOrDesc = sortBy?.desc ? 'desc_nulls_last' : 'asc_nulls_last';
    switch (sortBy?.id) {
        case 'route_number':
            return [{ route_number: ascOrDesc }];
        case 'route_name':
            return [{ route_alias: ascOrDesc }, { resource: { name: ascOrDesc } }, { route_number: ascOrDesc }];
        case 'scheduled_delivery':
            return [{ scheduled_delivery: ascOrDesc }];
        default:
            return [{ scheduled_delivery: 'desc_nulls_last' }, { route_number: 'desc_nulls_last' }];
    }
};
